import { ProfileServices } from '../profile/services';

let eventManageProfileServices = null;

export function getEventManageProfileServices(userId = null) {
    if (!eventManageProfileServices) {
        eventManageProfileServices = new ProfileServices();
    }

    const resolvedUserId = userId ?? (window.evedo?.userId ? parseInt(window.evedo.userId, 10) : 0);
    if (resolvedUserId) {
        eventManageProfileServices.set(resolvedUserId);
    }

    return eventManageProfileServices;
}

export function openEventManageDiscountCodes(eventId, userId = null) {
    getEventManageProfileServices(userId).manageDiscountCodes(eventId);
}

export function openEventManageEmbedTickets(eventId, userId = null) {
    getEventManageProfileServices(userId).embedTickets(eventId);
}

export function openEventManageBilling(eventId, userId = null) {
    getEventManageProfileServices(userId).openBillingInformation(eventId);
}
